import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { ToolAnalyzeContainer } from '../../styles';
import DescribeTablesCard from './DescribeTablesCard';
import ExecuteSQLCard from './ExecuteSQLCard';
import ListTablesCard from './ListTablesCard';
import { parseSQLToolData } from './parse';
import RawDataFallback from './RawDataFallback';
import { SQLCardContainer, SQLCardTitle } from './styles';
export const ToolSQLRenderer = ({ tool, toolName, }) => {
    var _a;
    const theme = useTheme();
    const { t } = useTranslation();
    const { resultData, parseError, args } = useMemo(() => parseSQLToolData(tool), [tool]);
    if (!((_a = tool.result) === null || _a === void 0 ? void 0 : _a.content)) {
        return null;
    }
    if (!resultData || parseError) {
        return (_jsx(ToolAnalyzeContainer, { children: _jsxs(SQLCardContainer, { children: [_jsx(SQLCardTitle, { children: _jsx(Typography, { elementTheme: "h5", color: theme.colors.black, children: t('assistant|tool_sql_results_title', 'Query Results') }) }), _jsx(RawDataFallback, { data: tool.result.content })] }) }));
    }
    switch (toolName) {
        case 'list_tables':
            return (_jsx(ListTablesCard, { resultData: resultData }));
        case 'describe_tables':
            return (_jsx(DescribeTablesCard, { resultData: resultData }));
        case 'execute_sql':
            return (_jsx(ExecuteSQLCard, { resultData: resultData, args: args }));
        default:
            return null;
    }
};
export default ToolSQLRenderer;
